module.exports = __webpack_public_path__ + "static/media/bq.f51f70c8.svg";